import { supplierPaths } from "@app/routing/adminPaths";
import { useBreadcrumb } from "@app/shared/components/Breadcrumb/useBreadcrumb";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useSupplier } from "./data";

export function useSupplierBreadcrumb() {
    const { supplier_id } = useParams();

    const { supplier } = useSupplier(supplier_id);

    const { t } = useTranslation("Navbar");

    const breadcrumbArgs = useMemo(() => {
        return [
            supplierPaths.supplier_id_param,
            supplier?.name ?? "...",
        ] as const;
    }, [supplier_id, supplier]);

    const setBreadcumb = useBreadcrumb();

    useEffect(() => {
        const [path, name] = breadcrumbArgs;
        setBreadcumb(path, name);
        setBreadcumb(supplierPaths.suppliers, t("suppliers"));
    }, [breadcrumbArgs]);
}
